import {CatalogProductsCriteriaBodyRestDto} from "@/api/pharma-cpc-product-mgmt/models";

export class CatalogProductsCriteriaBodyRestDtoModel implements CatalogProductsCriteriaBodyRestDto {
    filter_active_discount_scheme_id?: string | null;
    filter_category_code?: string | null;
    filter_cnk_codes?: string[] | null;
    filter_is_custom_name_available?: boolean | null;
    filter_is_custom_price_available?: boolean | null;
    filter_is_custom_sort_weight_available?: boolean | null;
    filter_is_products_in_subcategory_expected: boolean = false;
    filter_has_dp_reference_based_price?: boolean | null;
    filter_has_no_price?: boolean | null;
    filter_has_minimal_stock?: boolean | null;
    filter_has_maximum_order_quantity?: boolean | null;
    filter_has_price_from_software_sync?: boolean | null;
    filter_has_open_stock_notification_request?: boolean | null;
    filter_is_without_cnk?: boolean|null;
    filter_has_own_cnk?: boolean|null;
    filter_is_own_product?: boolean|null;
    filter_labo_code?: string | null;
    filter_product_codes?: string[] | null;
    filter_product_filter_code?: string | null;
    filter_trademark_code?: string | null;
    search_keyword?: string | null;

    constructor() {
    }

    public static createWithDefaults(): CatalogProductsCriteriaBodyRestDtoModel {
        return new this();
    }



    public copy(): CatalogProductsCriteriaBodyRestDtoModel {
        const model = CatalogProductsCriteriaBodyRestDtoModel.createWithDefaults();

        model.filter_cnk_codes = this.filter_cnk_codes;
        model.filter_active_discount_scheme_id = this.filter_active_discount_scheme_id;
        model.filter_category_code = this.filter_category_code;
        model.filter_is_products_in_subcategory_expected = this.filter_is_products_in_subcategory_expected;
        model.filter_labo_code = this.filter_labo_code;
        model.filter_product_filter_code = this.filter_product_filter_code;
        model.filter_trademark_code = this.filter_trademark_code;
        model.search_keyword = this.search_keyword;
        model.filter_is_custom_sort_weight_available = this.filter_is_custom_sort_weight_available;
        model.filter_is_custom_name_available = this.filter_is_custom_name_available;
        model.filter_is_custom_price_available = this.filter_is_custom_price_available;
        model.filter_has_no_price = this.filter_has_no_price;
        model.filter_has_minimal_stock = this.filter_has_minimal_stock;
        model.filter_has_maximum_order_quantity = this.filter_has_maximum_order_quantity;
        model.filter_has_price_from_software_sync = this.filter_has_price_from_software_sync;
        model.filter_has_open_stock_notification_request = this.filter_has_open_stock_notification_request;
        model.filter_is_without_cnk = this.filter_is_without_cnk;
        model.filter_has_own_cnk = this.filter_has_own_cnk;
        model.filter_is_own_product = this.filter_is_own_product;

        return model;
    }

}
